module.exports = __webpack_public_path__ + "static/media/woman_01.30c194f2.png";